// extracted by mini-css-extract-plugin
export default {"container":"WorkerDetail_container__rMMDt"};